import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify';
import 'vuetify/dist/vuetify.min.css' // Vuetify CSS 파일
// tiptapVuetify plugin
import './plugins/tiptap-vuetify'
import router from './router'
import axios from 'axios'

Vue.config.productionTip = false
Vue.prototype.$http = axios
Vue.prototype.$eventBus = new Vue()

// Vue.use(DatetimePicker)

Vue.use(vuetify, {
  iconfont: 'mdi'
})

new Vue({
  vuetify,
  router,
  render: h => h(App),

}).$mount('#app')
